import Vue from "vue";
import App from "./App.vue";
import router from "./router/router";
import store from "./store/store";
import vuetify from "./plugins/vuetify";
import "roboto-fontface/css/roboto/roboto-fontface.css";
import "@mdi/font/css/materialdesignicons.css";
import VueLodash from "vue-lodash";
import lodash from 'lodash/lodash';
import moment from "moment";
import "moment/locale/pt-br";
import Vuelidate from "vuelidate";
import VueMoment from "vue-moment";
import * as Sentry from "@sentry/browser";
import * as Integrations from "@sentry/integrations";
import "./directives/touch";
import "./directives/mask";

if (process.env.VUE_APP_SENTRY_DSN !== "") {
  Sentry.init({
    dsn: process.env.VUE_APP_SENTRY_DSN,
    environment: process.env.VUE_APP_SENTRY_ENV,
    integrations: [new Integrations.Vue({ Vue, attachProps: true })]
  });
  Sentry.configureScope(scope => {
    scope.setExtra(store.state);
  });
}

Vue.use(VueMoment, { moment });
Vue.use(VueLodash, { lodash });
Vue.use(Vuelidate);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
